module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.item.hidden) ? _c('div', {
    staticClass: "sideItem"
  }, [(_vm.hasOnlyChild(_vm.item.children, _vm.item) && (!_vm.childItem.children || _vm.childItem.noChild)) ? [(_vm.childItem.meta) ? _c('router-link', {
    attrs: {
      "to": _vm.resolvePath(_vm.childItem.path)
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": _vm.item.name
    }
  }, [_c('span', {
    staticClass: "title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.childItem.meta.title))])])], 1) : _vm._e()] : _c('el-submenu', {
    attrs: {
      "index": _vm.item.name,
      "popper-append-to-body": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.item.meta.title))])]), _vm._v(" "), _vm._l((_vm.item.children), function(child) {
    return _c('sidebar-item', {
      key: child.path,
      attrs: {
        "is-nest": true,
        "item": child,
        "basePath": _vm.resolvePath(child.path)
      }
    })
  })], 2)], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eade4d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/sideBar/item.vue
// module id = 454
// module chunks = 24